module.exports = __webpack_public_path__ + "img/Wish.65b0ee98.jpg";